import { ArrivalFactory } from '@/coreDomainsModule/factories/ArrivalFactory';
import { IRecommendOrder } from '../entities/RecommendOrder';
import { getRandomStr } from '@/businessRepository/idUtils';

/**
 * IRecommendOrderの初期値を生成するファクトリ
 */
export class RecommendOrderFactory {
  /**
   * IRecommendOrderを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<IRecommendOrder> = {}): IRecommendOrder => {
    const arrival = ArrivalFactory.create(initialData);
    return {
      ...arrival,
      displayId: initialData.displayId ?? getRandomStr(),
      orderNumber: initialData.orderNumber ?? '',
      orderAlert: initialData.orderAlert,
    };
  };
}
